<template>
    <div>

        <b-sidebar
                class="visible-xs"
                id="sidebar-backdrop-notifications"
                :backdrop-variant="variant"
                backdrop
                shadow
                no-header-close
        >
            <div class="logo">
                <img src="../../../../../static/logo.svg" alt="">
            </div>
            <div class="sidebar-menu">
                <ul>
                    <li>
                        <form class="form-inline" action="/action_page.php">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <i class="fa fa-search"></i>
                                </div>
                                <input type="text" class="form-control">
                            </div>
                        </form>
                    </li>
                    <li>

                        <b-card class="p-2" no-body border-variant="white" img-left>
                            <b-skeleton-img card-img="left" width="40px"></b-skeleton-img>
                            <b-card-body>
                                Nova Notificação
                            </b-card-body>
                        </b-card>

                        <b-card class="p-2" no-body border-variant="white" img-left>
                            <b-skeleton-img card-img="left" width="40px"></b-skeleton-img>
                            <b-card-body>
                                Nova Notificação
                            </b-card-body>
                        </b-card>

                        <b-card class="p-2" no-body border-variant="white" img-left>
                            <b-skeleton-img card-img="left" width="40px"></b-skeleton-img>
                            <b-card-body>
                                Nova Notificação
                            </b-card-body>
                        </b-card>

                        <b-card class="p-5" no-body border-variant="white">
                            <div>
                                <b-button block>Ver Todas</b-button>
                            </div>
                        </b-card>

                    </li>
                </ul>

            </div>
        </b-sidebar>


        <b-sidebar
                class="visible-xs"
                id="sidebar-backdrop1"
                :backdrop-variant="variant"
                backdrop
                shadow
                no-header-close
        >
            <div class="logo">
                <img src="../../../../../static/logo.svg" alt="">
            </div>
            <div class="sidebar-menu">
                <ul>
                    <li>
                        <form class="form-inline" action="/action_page.php">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <i class="fa fa-search"></i>
                                </div>
                                <input type="text" class="form-control">
                            </div>
                        </form>
                    </li>
                    <li>
                        <b-card class="text-center" border-variant="white">
                            <b-card-body border-variant="white">
                                <div>
                                    <b-skeleton animation="wave" width="85%"></b-skeleton>
                                    <b-skeleton animation="wave" width="55%"></b-skeleton>
                                    <b-skeleton animation="wave" width="70%"></b-skeleton>
                                </div>
                            </b-card-body>
                            <b-card-body border-variant="white">
                                <div>
                                    <b-skeleton animation="wave" width="85%"></b-skeleton>
                                    <b-skeleton animation="wave" width="55%"></b-skeleton>
                                    <b-skeleton animation="wave" width="70%"></b-skeleton>
                                </div>
                            </b-card-body>
                        </b-card>
                    </li>
                </ul>

            </div>
        </b-sidebar>


        <b-sidebar
                id="sidebar-backdrop"
                :backdrop-variant="variant"
                backdrop
                shadow
                no-header-close
        >
            <div class="logo">
                <img src="../../../../../static/logo.svg" alt="">
            </div>
            <div class="sidebar-menu">
                <ul>
                    <li><router-link :to="{ name: 'dashboard' }" ><i class="fa fa-bolt" ></i>Dashboard</router-link></li>
                    <li><router-link :to="{ name: 'clients' }"><i class="fa fa-users"></i>Clientes</router-link></li>
                    <li><router-link :to="{ name: 'services' }"><i class="fa fa-shopping-cart"></i>Serviços</router-link></li>
                    <li><router-link :to="{ name: 'products' }"><i class="fa fa-shopping-cart"></i>Produtos</router-link></li>
                    <li><router-link :to="{ name: 'receipts' }"><i class="fa fa-scroll"></i>Recibos</router-link></li>
                    <li><i class="fa fa-sticky-note"></i><a href="">NFS-e</a></li>
                    <li><router-link :to="{ name: 'os' }"><i class="fa fa-concierge-bell"></i>Ordem de Serviço</router-link></li>
                </ul>
                <div class="sidebar-separated">
                    <span>usos</span>
                    <hr>
                </div>
                <ul>
                    <li>Dashboard</li>
                    <li>Produtos</li>
                    <li>Clientes</li>
                    <li>NFS-e</li>
                    <li>Data</li>
                </ul>
            </div>
        </b-sidebar>
    </div>
</template>

<script>
    export default {
        name: "sidebarComponent",
        data() {
            return {
                variant: 'dark',
                variants: [
                    'transparent',
                    'white',
                    'light',
                    'dark',
                    'primary',
                    'secondary',
                    'success',
                    'danger',
                    'warning',
                    'info',
                ]
            }
        },

        methods: {}
    }
</script>

<style lang="scss" src="./../style.scss" scoped>


</style>